import { Injectable } from '@angular/core';
import { TalonarioAit } from '@tivic-team/manager-ts/dist/mob/entities/ait/talonario-ait.entity';
import { TalonarioAitController } from 'app/controllers/mob/talonario-ait.controller';
import { LoaderService } from '../loader.service';
import { TalonarioAitSearch } from './talonario-ait.search';


@Injectable()
export class TalonarioAitService {

  constructor(
    private _talonarioAitController: TalonarioAitController,
    private _loaderService: LoaderService
  ) {}

  async get(cdTalao:number):Promise<TalonarioAit>{
    
    this._loaderService.show();
    return this._talonarioAitController.get(cdTalao).finally(() => this._loaderService.hide());
  }

  async find( talonarioAitSearch?: TalonarioAitSearch ):Promise<TalonarioAit[]>{
    this._loaderService.show();
    try {  
      return await this._talonarioAitController.find(talonarioAitSearch && talonarioAitSearch.getFilters() || null )
      .finally(()=> this._loaderService.hide());
    } catch( error ) {
      return null;
    }
  }

  async save( talonarioAit: TalonarioAit ): Promise<TalonarioAit> {
    this._loaderService.show();

    if( talonarioAit.cdTalao && talonarioAit.cdTalao > 0) {
      console.log('update');
      return this._talonarioAitController.update( talonarioAit ).finally( () => this._loaderService.hide() );

    } else {
      console.log('Create');
      return this._talonarioAitController.create( talonarioAit ).finally(() => this._loaderService.hide());
    }
  }
}
